import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { GIButton } from 'app-components';
import { configs } from '@constants/configs/configs';
import { StyledIdentityHeader } from '../Layout';
import { BREAK_POINTS } from '@constants/common/breakpoints';
import { useAppSelector } from '@hooks/index';
import { environmentSelector } from '@selectors/commonSelectors';
import AlertMessage from '@components/individualPortal/dashboard/AlertMsgs/AlertMessage';
import { IUserInfo } from '../../types/ridpTypes';
import { useExchangeAndProgramNames } from '@reducers/appReducer';

const StyledIdentityButtonContainer = styled.div`
    display: flex;
    margin-bottom: 32px;
    justify-content: space-around;
    align-items: center;
    padding-top: 12px;
    @media (max-width: ${BREAK_POINTS.sm}) {
        display: block;
        > button {
            width: 100%;
        }
    }
    }

`;
const StyledButtonContent = styled.div`
    width: 83%;
    padding-right: 10px;
    color: ${({ theme }) => theme.gray2};
    font-size: ${({ theme }) => theme.fontSizeBody};
    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
        margin-bottom: 20px;
    }
`;

const StyledAlertContainer = styled.div`
    .gi-alert {
        padding: 24px;
        p {
            color: ${({ theme }) => theme.primaryDarkest};
        }
        li {
            margin-bottom: 12px;
            font-size: ${({ theme }) => theme.fontSizeBody};
            color: ${({ theme }) => theme.primaryDarkest};
        }
        font-size: ${({ theme }) => theme.fontSizeBody};
    }
`;
const GetStarted = () => {
    const {
        routes: { RIDP_CONTACT_INFO },
    } = configs;

    const navigate = useNavigate();

    const getQueryParam = (key: string) => {
        const location = useLocation();
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get(key);
    };
    const { exchangeName } = useAppSelector(environmentSelector);
    const { exchangeMedicaid } = useExchangeAndProgramNames();
    const currentUserInfo = useAppSelector(state => state.ridp.currentUserInfo) as IUserInfo | undefined;
    const isRidpRbaEnabled = currentUserInfo?.isRidpRbaEnabled === true;
    const caseNumber = getQueryParam('caseNumber');
    const coverageYear = getQueryParam('coverageYear');
    const applicationType = getQueryParam('applicationType');

    const navigateToContactInformation = () => {
        navigate(`${RIDP_CONTACT_INFO}?coverageYear=${coverageYear}&applicationType=${applicationType}${caseNumber ? `&caseNumber=${caseNumber}` : ''}`);
    };
    return (
        <main id="main-content" className="gi-panel">
            <StyledIdentityHeader className="h4">
                <FormattedMessage id="ridp.sidebar.getStarted.header" />
            </StyledIdentityHeader>

            <StyledIdentityButtonContainer>
                <StyledButtonContent>
                    <FormattedMessage id="ridp.sidebar.getStarted.buttonContent" />
                </StyledButtonContent>
                <GIButton
                    data-testid={'ridpGetStarted'}
                    type="button"
                    id="ridpGetStarted"
                    labelId="ridp.sidebar.getStarted"
                    onClickHandler={navigateToContactInformation}
                />
            </StyledIdentityButtonContainer>
            <StyledAlertContainer>
                <AlertMessage
                    type="info"
                    showIcon={false}
                    content={
                        <>
                            <h4>
                                <FormattedMessage id="ridp.sidebar.getStarted.para1.header" />
                            </h4>
                            <p>
                                <FormattedMessage id="ridp.sidebar.getStarted.para1.description" values={{ exchangeName, br: <br />, strong: chunks => <strong>{chunks}</strong> }} />
                            </p>
                            <h4>
                                <FormattedMessage id="ridp.sidebar.getStarted.para2.header" />
                            </h4>
                            {isRidpRbaEnabled ? (
                                <p>
                                    <FormattedMessage id="ridp.sidebar.getStarted.para2.description" values={{ exchangeName, exchangeMedicaid, br: <br />, strong: chunks => <strong>{chunks}</strong> }} />
                                </p>
                            ) : (
                                <ul>
                                    <li>
                                        <FormattedMessage id="ridp.sidebar.getStarted.para2.1" />
                                    </li>
                                    <li>
                                        <FormattedMessage id="ridp.sidebar.getStarted.para2.2" />
                                    </li>
                                    <li>
                                        <FormattedMessage id="ridp.sidebar.getStarted.para2.3" />
                                    </li>
                                </ul>
                            )}
                        </>
                    }
                />
            </StyledAlertContainer>
        </main>
    );
};

export default GetStarted;
